import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DeckPlanImage } from 'src/app/core/models/cruise';

@Component({
  selector: 'app-cruise-information-picture-carousel',
  templateUrl: './cruise-information-picture-carousel.component.html',
  styleUrls: ['./cruise-information-picture-carousel.component.scss']
})
export class CruiseInformationPictureCarouselComponent implements OnInit {

  @Input() public images: string[] = [];
  imagesObje: any[] = [];
  /*images =[
    {img: "https://testing.galavail.com/upload/fleet/Origin.jpg"},
    {img: "http://placehold.it/350x150/111111"},
    {img: "http://placehold.it/350x150/333333"},
    {img: "http://placehold.it/350x150/666666"}
  ]*/
  slideConfig = {
    "slidesToShow": 3,
    "slidesToScroll": 1,
    "nextArrow": "<div class='nav-btn slick-next'></div>",
    "prevArrow": "<div class='nav-btn slick-prev'></div>",
    "dots": true,
    "infinite": false,
    "autoplay": true,
    "arrows": true,
    "responsive": [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };
  constructor() {
    this.imagesObje = [];
  }

  ngOnInit() {
    this.buildImageObject();
  }
  buildImageObject() {
    this.imagesObje = this.images.map(item => {
      return { img: environment.cruisePhotosPathImg + item };
    })
  }
  boatPhotoDirectoryResource() {

  }
  slickInit(e: any) {
    // console.log('slick initialized');
  }

  breakpoint(e: any) {
    // console.log('breakpoint');
  }

  afterChange(e: any) {
    // console.log('afterChange');
  }

  beforeChange(e: any) {
    // console.log('beforeChange');
  }
  changeVisible() {
    // this.isOpenModal = false;
  }
  selectImage(value: DeckPlanImage, index: number) {
    console.log(index);
    /*
    this.selectedImage = value;
    this.selectedIndex = index;
    this.isOpenModal = true;*/
  }
}
